document.addEventListener("DOMContentLoaded", () => {
  const esunion = ["ES", "AD", "PT"]

  const eunion = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SL", "SE", "ES"]
  const urlParams = new URLSearchParams(window.location.search);
  const mainUrl = window.location.href;
  const queryString = mainUrl.split('?')[1];
  const path = document.querySelector('body').getAttribute('data-path') || window.location.pathname;
  const modifiedPath = path.replace("/es", "");
  async function fetchGeoLocation() {
    try {
      const { detected_values } = await fetch("/browsing_context_suggestions.json").then((res) => res.json())

      return detected_values.country.handle
    } catch (error) {
      throw error
    }
  }
   

  

  async function redirectUserToStore(countryIsoCode) {
    try {
      let redirectStoreKey = "es"
      let isRedirect = false

      if (esunion.includes(countryIsoCode)) {
        redirectStoreKey = "es"
      } else if (eunion.includes(countryIsoCode)) {
        redirectStoreKey = "eu"
      } else {
        redirectStoreKey = "row"
      }

      const currentStoreKey = window.location.host.split(".").at(0)
      if (currentStoreKey !== redirectStoreKey) {
        isRedirect = true
      }

      if (!["es", "row", "eu"].includes(currentStoreKey)) {
        isRedirect = false
      }

      if (isRedirect) {
        localStorage.setItem("redirected", Date.now())
        if (queryString?.length) {
          window.location.href = `https://${redirectStoreKey}.satorisan.com${modifiedPath}?${queryString}`
        } else {
           window.location.href = `https://${redirectStoreKey}.satorisan.com${modifiedPath}`
        }
        
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function init() {
    const { searchParams } = new URL(window.location.href)
    const countryIsoCode = await fetchGeoLocation()

    const lastRedirect = Number(localStorage.getItem("redirected"))
    let isRedirect = false
    
    if (lastRedirect === 0 || lastRedirect === NaN) {
      isRedirect = true
    }

    if (lastRedirect !== NaN && Date.now() - lastRedirect > 86400000) {
      isRedirect = true
    }

    if (searchParams.get("redirected")) {
      localStorage.setItem("redirected", Date.now())
      isRedirect = false
    }
    let openedFromInstagramShop = false;
    const utmSource = urlParams.get('utm_source');
    if (utmSource === 'IGShopping') {
      openedFromInstagramShop = true;
    }
    if(openedFromInstagramShop){
      isRedirect = true;
    } 
    if (document.referrer !== '' && !document.referrer.includes('satorisan')) {
      
      isRedirect = true;
    }

    if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
      isRedirect = false
    }

    if (isRedirect) {
      redirectUserToStore(countryIsoCode)
    }
    
    
  }

  init()
})
